module.exports = __webpack_public_path__ + "img/warning-modal-icon.66864c06.svg";